import { Box, styled } from "@mui/material";

export const SummaryCard = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex",
  overflow: "hidden",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.common.white,
  marginBottom: theme.spacing(2),
}));

export const AccentBar = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  width: 4,
  backgroundColor: theme.palette.secondary.main,
}));

export const SummaryColumn = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  padding: theme.spacing(2.5, 3),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: theme.spacing(0.5),

  "&:not(:last-of-type)": {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

export const IconBadge = styled(Box)(({ theme }) => ({
  height: 40,
  width: 40,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.primary.main,

  "& > svg": {
    fontSize: 20,
  },
}));
